<button class="close-btn" id="modal-close-btn">
 X
</button>
